/* eslint-disable import/prefer-default-export */
import moize from 'moize';
import MerchandisingConfig from '@/config/merchandising';
export const isGlobalModelType = moize((modelType) => modelType in MerchandisingConfig && MerchandisingConfig[modelType].global);
